import React from "react";
import { Navbar } from "react-bootstrap";
import LogoImg from "../../static/images/logo.png";
import styles from "./header.module.scss";

const Header = () => (
	<Navbar className={styles.header}>
		<div className={styles.container}>
			<div className={styles.logoContainer}>
				<img src={LogoImg} alt="logo" />
			</div>
		</div>
	</Navbar>
);

export { Header };
